import i18n from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

import { getNavigatorLanguage, normalizeLanguages } from '@mygpt/app/language';

import { KEY_TRANSLATE_LANGUAGE } from '@/constant';

// 匿名浏览器不支持storage
window.storageSupported = false;
try {
  window.storageSupported = navigator.cookieEnabled && typeof window.localStorage !== 'undefined';
} catch (e) {
  console.error(e);
}

const supportedLangs = ['en', 'ja', 'zh-Hant', 'zh-Hans', 'ko'];

// 改成只支持日语，且不需要跟随浏览器环境语言

// default lang
const lang =
  (typeof Storage !== 'undefined' && window.storageSupported && localStorage.getItem(KEY_TRANSLATE_LANGUAGE)) ||
  normalizeLanguages(getNavigatorLanguage())[0];

if (lang) {
  const index = supportedLangs.indexOf(lang);
  if (index > 0) {
    [supportedLangs[0], supportedLangs[index]] = [supportedLangs[index], supportedLangs[0]];
  }
  document.documentElement.lang = lang;
}

i18n
  .use(resourcesToBackend((language: string, namespace: string) => import(`../locales/${language}/${namespace}.json`)))
  .use(initReactI18next)
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    load: 'currentOnly',
    supportedLngs: supportedLangs,
    partialBundledLanguages: true,
    fallbackLng: supportedLangs[0],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });
